export const extractImageFileFromInputEvent = (event) =>
  event?.target?.files?.[0] ?? event?.currentTarget?.files?.[0] ?? null;

const collectionItemAt = (collection, index) => {
  if (!collection) return null;
  if (typeof collection.item === "function") {
    return collection.item(index);
  }
  return collection[index] ?? null;
};

const collectionIncludes = (collection, value) => {
  if (!collection) return false;
  if (typeof collection.includes === "function") {
    return collection.includes(value);
  }
  if (typeof collection.contains === "function") {
    return collection.contains(value);
  }

  for (let index = 0; index < (collection.length ?? 0); index += 1) {
    if (collectionItemAt(collection, index) === value) {
      return true;
    }
  }

  return false;
};

export const isImageFile = (file) =>
  Boolean(
    file &&
      typeof file.type === "string" &&
      file.type.toLowerCase().startsWith("image/"),
  );

const extractImageFileFromTransferItems = (items) => {
  if (!items) return null;

  for (let index = 0; index < (items.length ?? 0); index += 1) {
    const item = collectionItemAt(items, index);
    if (!item) continue;
    if (item.kind && item.kind !== "file") continue;
    if (
      typeof item.type === "string" &&
      item.type !== "" &&
      !item.type.toLowerCase().startsWith("image/")
    ) {
      continue;
    }

    const file = item.getAsFile?.();
    if (isImageFile(file)) {
      return file;
    }
  }

  return null;
};

const extractImageFileFromFileList = (files) => {
  if (!files) return null;

  for (let index = 0; index < (files.length ?? 0); index += 1) {
    const file = collectionItemAt(files, index);
    if (isImageFile(file)) {
      return file;
    }
  }

  return null;
};

export const extractImageFileFromDataTransfer = (dataTransfer) => {
  if (!dataTransfer) return null;

  return (
    extractImageFileFromTransferItems(dataTransfer.items) ??
    extractImageFileFromFileList(dataTransfer.files)
  );
};

export const extractImageFileFromClipboardEvent = (event) =>
  extractImageFileFromDataTransfer(
    event?.clipboardData ?? event?.nativeEvent?.clipboardData,
  );

export const extractImageFileFromDropEvent = (event) =>
  extractImageFileFromDataTransfer(
    event?.dataTransfer ?? event?.nativeEvent?.dataTransfer,
  );

export const dataTransferHasFiles = (dataTransfer) => {
  if (!dataTransfer) return false;
  if (collectionIncludes(dataTransfer.types, "Files")) return true;
  if ((dataTransfer.files?.length ?? 0) > 0) return true;

  const items = dataTransfer.items;
  for (let index = 0; index < (items?.length ?? 0); index += 1) {
    if (collectionItemAt(items, index)?.kind === "file") {
      return true;
    }
  }

  return false;
};

export const resetFileInputValue = (inputElement) => {
  if (!inputElement) return;
  inputElement.value = "";
};

export const buildImageSelection = (
  file,
  createObjectURL = (nextFile) => URL.createObjectURL(nextFile),
) => {
  if (!file) return null;

  return {
    file,
    previewUrl: createObjectURL(file),
  };
};

export const revokeImageSelection = (
  selection,
  revokeObjectURL = (url) => URL.revokeObjectURL(url),
) => {
  const previewUrl = selection?.previewUrl;
  if (!previewUrl) return;
  revokeObjectURL(previewUrl);
};
